import React, { useState } from "react";
import localStorage from "redux-persist/es/storage";
export const setToken = async (key, value) => {
  try {
    await localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
};

export const retrieveToken = async (key) => {
  const item = await localStorage.getItem(key)
  try {
    if (item) {
      return JSON.parse(item)
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const removeToken = async(key) => {
 return await localStorage.removeItem(key);
};
